import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Question from '../../../components/CASAForm/Question';
import StepNavigation from '../../../components/CASAForm/StepNavigation';
import {addRemovalType} from '../../../FormStore/Actions/FormDataActions/MPL/AddMPLFormData';
import {addPageAlert, clearPageAlert} from "../../../PortalStore/Actions/PageAlertActions";
import {getFormDataSelector} from "../../../FormStore/Selectors/FormDataSelectors";
import CustomBackLink from "../../../components/CASAForm/ReusableQuestions/CustomBackLink";


class MPLRemovalTypeSelection extends Component {
    constructor(props) {
        super(props);

        let removalType = '';
        let removalTypeLabel = '';

        if (props.formData?.removalType?.value) {
            removalType = props.formData.removalType.value;
            removalTypeLabel = props.formData?.removalType?.label;
        }

        this.state = {
            removalType: removalType,
            removalTypeLabel: removalTypeLabel,
            showError: false
        }
    }

    returnTypeSelection = (returnedQuestion) => {
        this.setState({
            removalType: returnedQuestion.answer.radioValue,
            removalTypeLabel: returnedQuestion.answer.value
        })
    };

    nextStep = () => {
        if (this.state.removalType) {

            this.props.dispatch(addRemovalType({
                value: this.state.removalType,
                label: this.state.removalTypeLabel
            }))
            this.props.onNextClick({value: this.state.removalType, label: this.state.removalTypeLabel});
            this.props.pageAlert?.level && this.props.dispatch(clearPageAlert());
        } else {
            this.setState({showError: true});
            this.props.dispatch(addPageAlert({
                level: "error",
                title: "There was a problem with the form",
                message: "Please check the form below and try again"
            }));
        }
    }

    previousStep = (e) => {
        e.preventDefault();
        this.props.onPreviousClick();
        this.props.pageAlert?.level && this.props.dispatch(clearPageAlert())
    }

    render() {

        return (
            <div id={this.props.id}>

                <CustomBackLink
                    id="previousStep"
                    action={this.previousStep}
                    text="Back"
                    direction="left"/>

                <h2>Removal details</h2>

                <Question
                    id="removalTypeSelection"
                    stepid="removalType"
                    type="radio"
                    label="Removal of exclusion is for"
                    returnQuestionData={this.returnTypeSelection}
                    showError={this.state.showError}
                    existingAnswer={{
                        value: this.state.removalTypeLabel,
                        radioValue: this.state.removalType
                    }}
                    radioSet={[
                        {
                            name: "category",
                            id: "category",
                            value: "category",
                            optionLabel: "Category"
                        },
                        {
                            name: "type",
                            id: "type",
                            value: "type",
                            optionLabel: "Type"
                        }
                    ]}/>

                <div className="form-controls au-form-group">
                    <StepNavigation
                        type='next'
                        label='Next'
                        action={this.nextStep}/>
                </div>
            </div>
        )

    }
}

MPLRemovalTypeSelection.propTypes = {
    properties: PropTypes.object,
    id: PropTypes.string,
    onPreviousClick: PropTypes.func,
    dispatch: PropTypes.func,
    onNextClick: PropTypes.func,
    pageAlert: PropTypes.object,
    formData: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        pageAlert: state.pageAlert
    }
}

export default connect(mapStateToProps)(MPLRemovalTypeSelection);